import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core'
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router'
import { takeUntil } from 'rxjs/operators'

import { DestroyService } from '@core/services/destroy.service'
import { MessengerService } from '../../services/messenger.service'
import { PermissionsSource } from '@core/types/permissions.source'
import { PermissionsService } from '@shared/services/permissions.service'
import { ChatModel } from '@shared/models/messenger/messenger.model'

@Component({
  selector: 'lin-messenger',
  templateUrl: './messenger.component.html',
  styleUrls: ['./messenger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  standalone: false,
})
export class MessengerComponent implements OnInit {
  private isShowDetail: boolean
  private chatList: ChatModel[]

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.toggleList()
  }

  get isChatCreate(): boolean {
    return this.permissionsService.hasPermissionSync(PermissionsSource['MESSENGER.CREATE_CHAT'])
  }

  constructor(
    public readonly messengerService: MessengerService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly destroyService: DestroyService,
    private readonly permissionsService: PermissionsService,
  ) {}

  ngOnInit(): void {
    this.toggleList()
    this.subscribeRouteEvents()
    this.subscribeChatList()
  }

  private subscribeRouteEvents(): void {
    const nextRouteEvent = (event: Event): void => {
      if (event instanceof NavigationEnd) {
        this.toggleList()
      }
    }

    this.router.events.pipe(takeUntil(this.destroyService)).subscribe(nextRouteEvent)
  }

  private toggleList(): void {
    const id = this.activatedRoute.firstChild.snapshot.paramMap.get('id')
    const isBigWidth = window.innerWidth >= 960
    const isShowList = id ? isBigWidth : true
    this.isShowDetail = id ? true : isBigWidth

    this.messengerService.isShowList.next(isShowList)
    this.messengerService.isShowDetail.next(this.isShowDetail)

    this.redirectToFirstChat(this.chatList)
  }

  private subscribeChatList(): void {
    const nextChatList = (chatList: ChatModel[]): void => {
      this.chatList = chatList
      this.redirectToFirstChat(chatList)
    }

    this.messengerService.chatList$.pipe(takeUntil(this.destroyService)).subscribe(nextChatList)
  }

  private redirectToFirstChat(chatList: ChatModel[]): void {
    const id = this.activatedRoute.firstChild.snapshot.paramMap.get('id')
    const chatId = chatList?.[0]?.id

    if (!id && this.isShowDetail && chatList?.length && chatId) {
      void this.router.navigate(['client', 'messenger', chatId])
    }
  }
}
